import { Link, useLocation } from "@tanstack/react-router";
import { useSichtErlaubt } from "@/api/me";

export const ADMIN_ZIELE = [
  ["/admin", "Übersicht"],
  ["/admin/upload", "Import"],
  ["/admin/archiv", "Archiv"],
  ["/admin/users", "Benutzer"],
  ["/admin/api-keys", "API-Schlüssel"],
] as const;
export function AdminNavigation() {
  const pfad = useLocation({ select: (location) => location.pathname });
  const erlaubt = useSichtErlaubt("/admin");
  if (!erlaubt || (pfad !== "/admin" && !pfad.startsWith("/admin/")))
    return null;
  return (
    <nav
      aria-label="Administration"
      className="mb-6 flex flex-wrap items-center gap-2 border-b border-line pb-3"
    >
      {ADMIN_ZIELE.map(([to, label]) => (
        <Link
          key={to}
          to={to}
          activeOptions={{ exact: to === "/admin" }}
          className="inline-flex min-h-11 items-center rounded-lg border border-line px-3 text-sm font-medium text-strong"
          activeProps={{ className: "bg-accent text-on-accent" }}
        >
          {label}
        </Link>
      ))}
      <a
        href="/docs"
        className="inline-flex min-h-11 items-center px-3 text-sm underline"
      >
        API-Dokumentation
      </a>
    </nav>
  );
}
